export function pickDirty<T extends Record<string, unknown>>(current: T, baseline: T): Partial<T> {
  const dirty: Partial<T> = {};
  for (const key of Object.keys(current) as (keyof T)[]) {
    if (current[key] !== baseline[key]) {
      dirty[key] = current[key];
    }
  }
  return dirty;
}

export function wrapPageIndex(index: number, count: number, delta: number): number {
  if (count === 0) return 0;
  return ((index + delta) % count + count) % count;
}

export function pageIdsAfterMove<T extends { id: string }>(
  pages: T[],
  activeId: string,
  overId: string,
): string[] | null {
  const ids = pages.map(p => p.id);
  const activeIndex = ids.indexOf(activeId);
  const overIndex = ids.indexOf(overId);
  if (activeIndex === -1 || overIndex === -1) return null;
  const next = [...ids];
  next.splice(activeIndex, 1);
  next.splice(overIndex, 0, activeId);
  return next;
}
